/**
 * Production/Azure environment settings
 * "production" settings are used for ALL Azure hosted environments (CI, QA, PROD).
 */
export const environment = {
    production: true,
    apiDomain: '' // Contructed by api.interceptor.ts: "api.[current-domain.dk]".
};
